module.exports = __webpack_public_path__ + "img/28_19.f7249539.png";